import { isRequired } from '../../../utils/validation';

export const initialValues =  {
  options: '1',
  kbliVersion: '2020',
  businessTypeName: '',
  codeKbli: '',
  description: '',
};

export const validate = (values) => {
  const { options } = values;
  if(options === '1'){
    const { businessTypeName, codeKbli, kbliVersion, description } = values;
    const wordCount = businessTypeName.trim().split(/\s+/).length;
    return {
      kbliVersion: isRequired(kbliVersion, 'Tahun KBLI harus diisi'),
      businessTypeName: isRequired(businessTypeName, 'Nama Jenis Usaha harus diisi')
      || (wordCount > 20 && 'Maksimal 20 kata')
      || ((!/^[a-zA-Z\s()/,&]+$/.test(businessTypeName) || /^\s*$/.test(businessTypeName)) && 'Hanya dapat karakter huruf, koma dan simbol () & /'),
      codeKbli: isRequired(codeKbli, 'Kode KBLI harus diisi') || (!/^[0-9]*$/.test(codeKbli) && 'Hanya dapat karakter angka') || (codeKbli.length > 10 && 'Maksimal 10 karakter'),
      description: isRequired(description, 'Deskripsi harus diisi'),
    };
  }
};
